<template>
	<transition
		type="transition"
		@before-enter="initializePosition"
		@enter="animateWalk"
		@after-enter="completeWalk"
	>
		<div class="cover cat-animation" :class="[name, animationClass]"></div>
	</transition>
</template>

<script>
import soundFx from '@/mixins/sound-fx';
import { setElementStyles } from '@/mixins/element-attrs';
import { whichAnimationEnd } from '@/mixins/event-detection';

const animationEnd = whichAnimationEnd();

export default {
	name: 'Walk',
	mixins: [soundFx],
	props: {
		name: "",
		walkDistance: 0,
		walkDuration: 0,
		speed: {
			type: Number,
			default: 4,
		},
	},
	data() {
		return {
			isWalking: false,
		};
	},
	computed: {
		animationClass() {
			return this.isWalking ? "walk" : "sit";
		},
		travelDuration() {
			return (this.walkDistance * this.speed * this.walkDuration);
		},
		offScreenPosition() {
			return -this.walkDistance * 100;
		},
		timerID() {
			return `steps-${this.componentID}`;
		},
	},
	methods: {
		initializePosition(element) {
			setElementStyles(element, { transform: `translateX(${this.offScreenPosition}%)` });
		},
		animateWalk(element) {
			this.$nextTick(() => {
				this.isWalking = true;
				requestAnimationFrame(() => {
					this.footsteps();
					setElementStyles(element, {
						transform: `translateX(0)`,
						transitionDuration: `${this.travelDuration}s`,
					});
				});
			});
		},
		completeWalk() {
			this.isWalking = false;
			this.$el.addEventListener(animationEnd, () => {
				this.$emit("walkComplete");
			});
		},
		footsteps() {
			const steps = 8;
			this.$store.commit("addTimer", {
				duration: ((this.travelDuration * 1000) / steps),
				repeat: steps,
				ref: this.timerID,
				action: () => {
					this.playRandomSound("footstep");
				},
			});
		},
	},
	beforeDestroy() {
		if (this.$store.getters.timerExists(this.timerID)) {
			this.$store.dispatch("removeTimer", { ref: this.timerID });
		}
	},
};
</script>

<style lang="scss" scoped>
	.cat-animation {
		@include cover;
		z-index: 10;
		pointer-events: none;

		transition-property: transform;
		transition-timing-function: linear;

		// override inilne transition, avoids keeping element in dom after animations complete
		&.v-leave-active {
			transition: none !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/cat/Walk.vue